module.exports = __webpack_public_path__ + "static/media/end-call -grey.e1c31454.svg";